import { CONFIG_OAUTH_UPDATE, CONFIG_UPDATE } from './types';
const initialState = {
  langFallBack: {},
  langWhiteList: [],
  lsApi: '',
  lslApi: '',
  easterEggKeys: {},
  printStateModel: {},
  regionalMap: {},
  privacyPolicy: {},
  termsOfUse: {}
};
export const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_UPDATE:
      return {
        ...state,
        ...action.config
      };
    case CONFIG_OAUTH_UPDATE:
      return {
        ...state,
        privacyPolicy: action.privacyPolicy,
        termsOfUse: action.termsOfUse
      };
    default:
      return state;
  }
};